import { useMemo } from 'react'

import { MaxChatMessage, MaxSessionStatus } from '../types'

type UseMaxMessagesParams = {
  chatId: string | undefined
  activeConversationId: string | null
  tempConversationId: string | null
  awaitingConversationId: string | null
  isTyping: boolean
  messagesByConversation: Record<string, MaxChatMessage[]>
  sessionStatus: MaxSessionStatus
}

const useMaxMessages = ({
  chatId,
  activeConversationId,
  tempConversationId,
  awaitingConversationId,
  isTyping,
  messagesByConversation,
  sessionStatus,
}: UseMaxMessagesParams) => {
  const currentConversationId =
    activeConversationId || tempConversationId || chatId || awaitingConversationId

  const currentMessages = useMemo(() => {
    if (!currentConversationId) return []
    return messagesByConversation[currentConversationId] || []
  }, [currentConversationId, messagesByConversation])

  const hasMessages = currentMessages.length > 0
  const isSendDisabled = sessionStatus !== 'ready' || isTyping

  return {
    currentConversationId,
    currentMessages,
    hasMessages,
    isTyping,
    isSendDisabled,
  }
}

export default useMaxMessages
